import React, { useEffect, useState,useRef } from "react";
import "./Article.css";
import { useLocation, useNavigate } from "react-router";
import { Button, LinearProgress } from "@mui/material";
import EditArticle from "../EditArticle/EditArticle";
import moment from "moment";
import big from "../images/big.png";
import { Markup } from "interweave";
import SideBar from "../SideBar/SideBar";
import axiosApiInstance from "../axios";
import AllTicketsHeader from "../AllTickets/AllTicketsHeader";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import Tooltip from "@mui/material/Tooltip";
import download from 'js-file-download';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import FileCopyIcon from '@mui/icons-material/FileCopy';


function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
  };
}


const Article = () => {

  
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setloading] = useState(true);
  const [currentArticle, setCurrentArticle] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const location = useLocation();
  const id = location.pathname.split("/")[2];

  const [copy, setCopy] = useState(false);
  const url = window.location.href;

  const [elementTag, setElementTag] = useState([]);
  const [elementCategory, setElementCategory] = useState([]);

 

  useEffect(() => {
    // add axios here
    setTimeout(() => {
      axiosApiInstance
        .get(`/article/${id}`)
        .then((res) => {
          setCurrentArticle(res.data.data);
          setElementTag(res.data.data.tag);
          setElementCategory(res.data.data.category);
          setloading(false);
        })
        .catch((err) => console.log(err));
    }, 200);
  }, [id, isEdit]);

  const config = { responseType: 'blob' };

  const downloadFile = (filename) => {
    axiosApiInstance.get(`/article/${filename}/${id}`,config).then(res => {
     download(res.data,filename);
      			})
      
    .catch((error) => {
      console.error("Error:", error);
    });
  }

  const editArt = () => {
    setIsEdit(!isEdit);
  };

  const searchHandler = (searchTerm) => {
    setSearchTerm(searchTerm);
  };

  const navigate = useNavigate();
  return (
    <>
      <AllTicketsHeader searchKeyword={searchHandler} term={searchTerm} />
      <SideBar />
      {isEdit ? (
        <EditArticle
          currentArticle={currentArticle}
          file={currentArticle.fileName}
          id={id}
          onEditChange={editArt}
          tag={elementTag}
          catg={elementCategory}
        />
      ) : (
        <div className="article">
          <div className="article-right">
            <div className="art-controls">
              <div className="controls-left">
                <div>
                  <Button
                    className="A-back-btn"
                    onClick={() => navigate("/knowledge")}
                    style={{
                      backgroundColor: "#0A387D",
                    }}
                    variant="contained"
                  >
                    Back
                  </Button>
                </div>
                <div>
                  <Button
                    className="A-back-btn"
                    style={{
                      backgroundColor: "#0A387D",
                    }}
                    variant="contained"
                    onClick={editArt}
                  >
                    Edit
                  </Button>
                </div>
              </div>

              <div className="controls-right">
                <Button
                  className="A-back-btn"
                  style={{
                    backgroundColor: "#0A387D",
                  }}
                  variant="contained"
                  onClick={() => navigate("/add")}
                >
                  <span>+</span>Create Article
                </Button>
              </div>
            </div>

            {loading ? (
              <>
                <br /> <LinearProgress />
              </>
            ) : (
              <div>
                <div className="art-label-id">
                  {/* <span>Id</span> */}

                  <AvatarGroup className="art-profile" max={3}>
                    <Tooltip title={currentArticle.createdBy} arrow>
                      <Avatar  {...stringAvatar(currentArticle.createdBy)}
                        src={currentArticle.createdBy}
                      />
                    </Tooltip>

                    {currentArticle.createdBy === currentArticle.modifiedBy || currentArticle.modifiedBy=== null ? (
                      " "
                    ) : (
                      <>
                        <Tooltip title={currentArticle.modifiedBy} arrow>
                          <Avatar  {...stringAvatar(currentArticle.modifiedBy)}
                            src={currentArticle.modifiedBy}
                          />
                        </Tooltip>
                      </>
                    )}
                  </AvatarGroup>
                </div>

                <div className="art-right-first">
                  <div className="copy-hover-field">
                  <span className="art-id" >{currentArticle.id}</span>
                  <CopyToClipboard text={url} onCopy={()=> setCopy(true)}>
                <Tooltip  title={copy ? "Copied! ": "Copy Article "} arrow>
                 
                  <FileCopyIcon className="file-copy-icon" />
                  </Tooltip>
                  </CopyToClipboard>
                  </div>
                
                  <p className="art-date">
                    {moment(currentArticle.createdDate).format("MMMM Do YYYY")}
                  </p>
                </div>
                <div className="art-title">
                  <p className="art-label-title">Title</p>
                  <p>{currentArticle.title}</p>
                </div>

                <div className="art-desc">
                  <p className="art-label-desc">Description</p>
                  {<Markup content={currentArticle.description} />}
                </div>

                {elementTag?.length > 0 ? (
                  <>
                    <div className="art-tag">
                      <p className="art-label-tag">Tag</p>
                      {elementTag?.map((ele, index) => (
                        <span className="tag-item" key={index}>
                          {ele}
                        </span>
                      ))}
                    </div>
                  </>
                ) : (
                  ""
                )}

                {elementCategory?.length > 0 ? (
                  <>
                    {" "}
                    <div className="art-tag">
                      <p className="art-label-tag">Category</p>
                      {elementCategory?.map((catg) => (
                        <span className="tag-item">{catg}</span>
                      ))}
                    </div>
                  </>
                ) : (
                  ""
                )}

                {currentArticle?.attachments?.length > 0 ? (
                  <>
                    {" "}
                    <p className="attach-label">Attachment</p>
                  </>
                ) : (
                  ""
                )}
                {
                  currentArticle?.attachments && currentArticle?.attachments?.map((attach,id)=>
                  (
                    <div className="show-art" >
                  <span
                    className="art-show-file" >
                    {attach.fileName}

                   
                        <FileDownloadOutlinedIcon
                          className="file-attach-icon"
                          type="button"
                          onClick={() => {
                            downloadFile(
                              attach.fileName
                            );
                          }}
                        />
                     
                  </span>
                  <div>{/* <p> {currentArticle.modifiedDate}</p> */}</div>
                </div>
                  ))
                }

              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Article;
